/* eslint-disable sonarjs/no-duplicate-string */

export const schemaMarkupsByPath = {
  "/": {
    "@context": "https://schema.org",
    "@type": ["Organization", "InsuranceAgency"],
    name: "Afa Försäkring",
    url: "https://www.afaforsakring.se",
    logo: "https://www.afaforsakring.se/images/icons/afa-forsakring-blue.svg",
    description:
      "Afa Försäkring ger trygghet genom kollektivavtalad försäkring vid sjukdom, arbetsskada, arbetsbrist, dödsfall och föräldraledighet. Vi ägs av Svenskt Näringsliv, LO och PTK och försäkrar 5 miljoner människor i Sverige.",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Klara Södra kyrkogata 18",
      addressLocality: "Stockholm",
      postalCode: "106 27",
      addressCountry: "SE",
    },
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+46 771 88 00 99",
      contactType: "customer service",
      availableLanguage: ["Svenska", "Engelska"],
    },
    sameAs: [
      "https://se.linkedin.com/company/afa-forsakring",
      "https://www.facebook.com/afaforsakring",
    ],
  },
  "/om-oss": {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    url: "https://www.afaforsakring.se/om-oss",
    name: "Om Afa Försäkring",
    mainEntity: {
      "@type": ["Organization", "InsuranceAgency"],
      name: "Afa Försäkring",
      url: "https://www.afaforsakring.se",
      logo: "https://www.afaforsakring.se/images/icons/afa-forsakring-blue.svg",
      description:
        "Afa Försäkring ger trygghet genom kollektivavtalade försäkringar vid sjukdom, arbetsskada, arbetsbrist, föräldraledighet och dödsfall. Vi ägs av arbetsmarknadens parter – Svenskt Näringsliv, LO och PTK – och försäkrar över 5 miljoner människor i Sverige.",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Klara Södra kyrkogata 18",
        postalCode: "106 27",
        addressLocality: "Stockholm",
        addressCountry: "SE",
      },
      sameAs: [
        "https://se.linkedin.com/company/afaforsakring",
        "https://www.facebook.com/afaforsakring",
      ],
    },
  },
  "/om-oss/kontakta-oss": {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    url: "https://www.afaforsakring.se/om-oss/kontakta-oss",
    mainEntity: {
      "@type": ["Organization", "InsuranceAgency"],
      name: "Afa Försäkring",
      url: "https://www.afaforsakring.se",
      contactPoint: [
        {
          "@type": "ContactPoint",
          telephone: "+46 771 88 00 99",
          contactType: "customer service",
          areaServed: "SE",
          availableLanguage: ["Svenska", "Engelska"],
        },
        {
          "@type": "ContactPoint",
          contactType: "kundtjänstformulär",
          url: "https://www.afaforsakring.se/kundtjanst/skicka-meddelande",
          availableLanguage: ["Svenska", "Engelska"],
          areaServed: "SE",
        },
      ],
    },
  },
  "/forsakring/sjukforsakring": {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Sjukförsäkring",
    description: "Kompletterar ersättning från Försäkringskassan vid sjukdom.",
    serviceType: "Sjukförsäkring",
    areaServed: {
      "@type": "Country",
      name: "Sverige",
    },
    provider: {
      "@type": "Organization",
      name: "Afa Försäkring",
      url: "https://www.afaforsakring.se",
    },
  },
  "/forsakring/arbetsskadeforsakring": {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Arbetsskadeförsäkring",
    description: "Kan ge ersättning vid fysisk eller psykisk personskada på jobbet.",
    serviceType: "Arbetsskadeförsäkring",
    areaServed: {
      "@type": "Country",
      name: "Sverige",
    },
    provider: {
      "@type": "Organization",
      name: "Afa Försäkring",
      url: "https://www.afaforsakring.se",
    },
  },
  "/forsakring/forsakring-vid-arbetsbrist-agb": {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Försäkring om avgångsbidrag",
    description:
      "Om du är 40 år eller äldre och har blivit uppsagd på grund av arbetsbrist kan du ha rätt till ersättning från Försäkring om avgångsbidrag AGB.",
    serviceType: "Avgångsbidrag",
    areaServed: {
      "@type": "Country",
      name: "Sverige",
    },
    provider: {
      "@type": "Organization",
      name: "Afa Försäkring",
      url: "https://www.afaforsakring.se",
    },
  },
  "/forsakring/forsakring-vid-dodsfall": {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Försäkring vid dödsfall",
    description:
      "Vid dödsfall kan dina närstående få ekonomisk hjälp från Tjänstegrupplivförsäkringen TGL",
    serviceType: "Försäkring vid dödsfall",
    areaServed: {
      "@type": "Country",
      name: "Sverige",
    },
    provider: {
      "@type": "Organization",
      name: "Afa Försäkring",
      url: "https://www.afaforsakring.se",
    },
  },
  "/forsakring/foraldrapenningtillagg": {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Föräldrapenningtillägg",
    description: "Försäkringen kan ge ersättning när man är föräldraledig från sin anställning",
    serviceType: "Extra ersättning vid föräldraledighet",
    areaServed: {
      "@type": "Country",
      name: "Sverige",
    },
    provider: {
      "@type": "Organization",
      name: "Afa Försäkring",
      url: "https://www.afaforsakring.se",
    },
  },
  "/forsakring/avsattning-till-tjanstepension/avgiftsbefrielseforsakring": {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Avgiftsbefrielseförsäkring",
    description:
      "Försäkringen betalar pensionsavgiften till din avgiftsbestämda tjänstepension när du får sjuk- eller aktivitetsersättning från Försäkringskassan eller om du får arbetsskadelivränta",
    serviceType: "Betalning av pensionsavgift",
    areaServed: {
      "@type": "Country",
      name: "Sverige",
    },
    provider: {
      "@type": "Organization",
      name: "Afa Försäkring",
      url: "https://www.afaforsakring.se",
    },
  },
  "/forsakring/avsattning-till-tjanstepension/premiebefrielseforsakring-vid-foraldraledighet": {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Premiebefrielseförsäkring vid föräldraledighet",
    description:
      "Försäkringen betalar in premier till tjänstepension när man är föräldraledig eller får graviditetspenning",
    serviceType: "Inbetalning av premier till tjänstepension",
    areaServed: {
      "@type": "Country",
      name: "Sverige",
    },
    provider: {
      "@type": "Organization",
      name: "Afa Försäkring",
      url: "https://www.afaforsakring.se",
    },
  },
  "/forsakring/avsattning-till-tjanstepension/premiebefrielseforsakring-vid-sjukdom-eller-arbetsskada":
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "Premiebefrielseförsäkring vid sjukdom eller arbetsskada",
      description:
        "Försäkringen betalar in premier till tjänstepension när man är sjukskriven på grund av sjukdom, arbetsskada eller om man har arbetsskadelivränta.",
      serviceType: "Inbetalning av premier till tjänstepension",
      areaServed: {
        "@type": "Country",
        name: "Sverige",
      },
      provider: {
        "@type": "Organization",
        name: "Afa Försäkring",
        url: "https://www.afaforsakring.se",
      },
    },
};
